module.exports = __webpack_public_path__ + "static/media/Golden tower 10-mobile.773bfd5f.webp";